module.exports = __webpack_public_path__ + "static/media/icon-calendar.2ddf340f.svg";